import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";
import BrandLogo from "./BrandLogo";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-zinc-200/50" data-testid="navbar">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 font-extrabold text-zinc-950 tracking-tight" data-testid="navbar-brand">
            <BrandLogo variant="mark" size={28} />
            <span className="text-[15px] sm:text-base">
              fastprototype<span className="bg-gradient-to-r from-emerald-400 to-sky-500 bg-clip-text text-transparent">.ai</span>
            </span>
          </Link>
          <div className="hidden md:flex items-center gap-6">
            <a href="/#how-it-works" className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors">{t("nav.how_it_works")}</a>
            <Link to="/about" data-testid="navbar-about" className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors">{t("nav.about")}</Link>
            <Link to="/customer/login" data-testid="navbar-customer-login" className="text-sm font-medium text-zinc-600 hover:text-zinc-900 transition-colors">{t("nav.my_projects")}</Link>
            <LanguageSwitcher compact />
            <button data-testid="navbar-cta" onClick={() => navigate("/build")}
              className="inline-flex items-center px-5 py-2 text-sm font-semibold text-white bg-zinc-950 rounded-full hover:bg-zinc-800 transition-colors">
              Build my Prototype
            </button>
          </div>
          <button className="md:hidden" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-testid="navbar-mobile-toggle">{open ? <X size={20} /> : <Menu size={20} />}</button>
        </div>
      </div>
      {open && (
        <div className="md:hidden bg-white border-t border-zinc-100 px-4 py-4 space-y-3">
          <a href="/#how-it-works" className="block text-sm font-medium text-zinc-700 py-2" onClick={() => setOpen(false)}>{t("nav.how_it_works")}</a>
          <Link to="/about" className="block text-sm font-medium text-zinc-700 py-2" onClick={() => setOpen(false)}>{t("nav.about")}</Link>
          <Link to="/customer/login" className="block text-sm font-medium text-zinc-700 py-2" onClick={() => setOpen(false)}>{t("nav.my_projects")}</Link>
          <div className="py-2"><LanguageSwitcher /></div>
          <button onClick={() => { navigate("/build"); setOpen(false); }}
            className="w-full py-3 text-sm font-semibold text-white bg-zinc-950 rounded-full hover:bg-zinc-800 transition-colors">
            Build my Prototype
          </button>
        </div>
      )}
    </nav>
  );
}
